/**
 * @desc 全局设置
 */
export const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCsOD0oHb007bxLJwjkMZA5N44eZ3xUxm89jnHgpmP8Cy1+5b8gKWOiVMkHB4WAn2eblciwevpGNJH80b9G0ic52Shr5FlzOzek55NN24CSaTFNMjVFHkt6KtdUnGYanvyFVlRzwX119Oii7YQHhNYPSl6Zqk2I+N5gTkmtvpCJRQIDAQAB';
export const baseUrl = '//apiswise.123cx.com';
export const baseUrl1 = '//authwise.123cx.com';
export const baseUrl2 = '//apiswise.123cx.com';
export const vendorUrl = process.env.VUE_APP_STATUS === 'official' ? '//fed-static.123cx.com/vendor' : '//wisetest.123cx.com/itbus2.5/vendor';
export const componentUrl = process.env.VUE_APP_STATUS === 'official' ? '//fed-static.123cx.com/components' : '//wisetest.123cx.com/itbus2.5/components';
export const moduleUrl = `${location.pathname.slice(0, -1)}/modules`;
export const wsUrl = 'https://socket4.123cx.com/pull_data';
export default {vendorUrl, componentUrl, moduleUrl, publicKey, baseUrl, wsUrl};
